export const CHAT_ATTACHMENT_MAX_FILE_SIZE_BYTES = 80 * 1024 * 1024;
export const CHAT_ATTACHMENT_MAX_FILES = 10;

export function getChatAttachmentFileKey(file: File) {
  return `${file.name}-${file.size}-${file.lastModified}`;
}
